import { FC, useState } from 'react';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input/Input';

import { EListsTypes } from 'types/listsTypes';

interface ISaveFiltersProps {
  listType: EListsTypes,
  onModalClose: () => void,
}

const SaveFilters: FC<ISaveFiltersProps> = ({ onModalClose }) => {
  // const dispatch = useDispatch();
  const [name, setName] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSave = async() => {
    setIsLoading(true);
    // await dispatch(saveActiveFiltersByTypeAction({ name, listType }));
    onModalClose();
  };

  return (
    <div className="w-400">
      <h2>Save Filter</h2>
      <p className="m-b-5">Filter Name</p>
      <div className="d-f ai-c">
        <Input
          size="large"
          value={name}
          placeholder="Enter Filter Name"
          onChange={({ target: { value } }) => setName(value)}
        />
        <Button
          size="large"
          type="primary"
          className="m-l-10"
          disabled={!name}
          loading={isLoading}
          onClick={handleSave}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default SaveFilters;
